export var ComparisonPeriod;
(function (ComparisonPeriod) {
    ComparisonPeriod["Current"] = "current";
    ComparisonPeriod["Previous"] = "previous";
    ComparisonPeriod["Team"] = "team";
})(ComparisonPeriod || (ComparisonPeriod = {}));
